import { render, staticRenderFns } from "./InventoryPolicies.vue?vue&type=template&id=763ab90c&scoped=true"
import script from "./InventoryPolicies.vue?vue&type=script&lang=js"
export * from "./InventoryPolicies.vue?vue&type=script&lang=js"
import style0 from "./InventoryPolicies.vue?vue&type=style&index=0&id=763ab90c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "763ab90c",
  null
  
)

export default component.exports